import React from 'react';
import { HeartIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
export function About() {
  const values = [{
    icon: ShieldCheckIcon,
    title: 'Honesty That Builds Trust',
    description: 'Open communication, clear estimates, and realistic timelines. No hidden fees, no empty promises. Just straightforward answers and dependable work you can trust.'
  }, {
    icon: HeartIcon,
    title: 'Integrity in Every Job',
    description: 'We stand behind our workmanship and honor every commitment. From showing up on time to doing the job right the first time, we treat your home with respect.'
  }, {
    icon: UsersIcon,
    title: 'Compassion for Our Community',
    description: 'We actively support local causes and community events. Whether volunteering our time or helping families in need, we believe in making a positive impact that lasts.'
  }];
  return <div className="w-full bg-gradient-to-br from-yellow-400 via-yellow-300 to-yellow-400 py-20 px-4" data-id="element-12">
      <div className="max-w-7xl mx-auto" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <div className="flex justify-center mb-6" data-id="element-15">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/u53GDs2EPCe9qQT6kzQQ7V/MHDlogo-icon.png" alt="Mobile Home Doctor Logo" className="w-24 h-24" data-id="element-16" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6" data-id="element-17">
            From Roof to Foundation — Florida's Home Doctor Is In
          </h2>
          <p className="text-xl text-black max-w-4xl mx-auto leading-relaxed" data-id="element-18">
            Our mission is simple — to keep your mobile home safe, comfortable,
            and built to last. We combine expert craftsmanship with values that
            never change: honesty, integrity, and compassion. We treat every
            project like it's our own home, because we know that quality repairs
            and dependable service matter most when you're protecting where you
            live.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-19">
          {values.map((value, index) => {
          const Icon = value.icon;
          return <div key={index} className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow" data-id="element-20">
                <div className="bg-red-600 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-21">
                  <Icon className="w-8 h-8 text-white" data-id="element-22" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-23">
                  {value.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-24">
                  {value.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </div>;
}